import React, { useState} from "react";
import { BUTTON, TEXTBOX, POLL_TYPE, POLL_SHARE_MODE } from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {YuJaRadioBox} from "../standardization/YuJaRadiobox";
import classes from "../../pages/ReleaseActivityPage/ReleaseActivityPage.module.css";
import settingsClasses from "../../pages/PlatformSetting/Settings.module.css";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function EndPollModal({setModalShow, show, localState, poll, handleStop, handleStopAll}) {
    const { t } = useTranslation();
    const {isPPTPage} = usePPTWebView();
    const { serialNo } = useParams();

    const OPTIONS = {POLL: "POLL", QUESTION: "QUESTION"}
    const [selectedOpt, setSelectedOpt] = useState(OPTIONS.QUESTION);
    const [isSaving, setIsSaving] = useState(false);

    let isSharing = poll.pollType !== POLL_TYPE.ATTENDANCE && (localState === "GET_READY" || localState === "SHARED");

    const handleClose = () =>{
        setModalShow(false);
    };




    const handleSave = async () => {
        setIsSaving(true);
        try {
            if (isSharing) {
                if (selectedOpt === OPTIONS.QUESTION) {
                    await handleStop();
                } else {
                    await handleStop(true);
                }
            } else {
                if (poll.pollType === POLL_TYPE.ATTENDANCE) {
                    await handleStop();
                } else if (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE || poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL) {
                    await handleStopAll();
                } else {
                    await handleStop(true);
                }
            }
        } finally {
            setIsSaving(false);
            setModalShow(false);
        }
    }


    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"save-question-bank-modal"}
        >

            <ModalClose
                tabIndex={0}
                role={BUTTON}
                aria-label={t("common.close")}
                onClick={handleClose}
                className="modal-close"
                style={{width: "24px", height: "24px"}}
            />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title">
                    {isSharing
                        ? t("questionBuilder.endNowMultiOptionsText")
                        : (poll.pollType === POLL_TYPE.ATTENDANCE ? t("attendance.finishAttendanceTitle") : t("questionBuilder.finishPoll"))
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, padding: 20, minHeight: isSharing ? 150 : 80}}>
                {isSharing &&
                    <>
                        <span className={classes.description}>
                            {t("questionBuilder.endNowDescriptionMultiOptions")}
                        </span>

                        <div className={classes.row}>
                            <span className={settingsClasses.settingLabel}>{t("questionBuilder.endNowOptionsText")}</span>
                            <span style={{width: 70}}/>
                            <YuJaRadioBox
                                size={18}
                                labelStyle={{fontSize: 14, fontWeight: "400", lineHeight: 1.6}}
                                label={t("questionBuilder.entirePollText")}
                                checked={selectedOpt === OPTIONS.POLL}
                                onClick={() => setSelectedOpt(OPTIONS.POLL)}
                            />
                            <span style={{width: 40}}/>
                            <YuJaRadioBox
                                size={18}
                                labelStyle={{fontSize: 14, fontWeight: "400", lineHeight: 1.6}}
                                label={isPPTPage() && poll.liveQuestionNo !== parseInt(serialNo)
                                    ? t("accessibility.questionLabel") + " " + poll.liveQuestionNo
                                    : t("questionBuilder.currentQuestionText")
                                }
                                checked={selectedOpt === OPTIONS.QUESTION}
                                onClick={() => setSelectedOpt(OPTIONS.QUESTION)}
                            />
                        </div>
                    </>
                }

                {!isSharing &&
                    <span className={classes.description}>
                        {poll.pollType === POLL_TYPE.ATTENDANCE ? t("attendance.finishAttendanceDescription") : t("questionBuilder.finishPollDescription")}
                    </span>
                }

            </Modal.Body>
            <Modal.Footer>
                <div
                    style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                    <span style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center", justifyContent: "flex-end", gap: 10
                    }}>
                        <YuJaButton
                            onClick={handleClose}
                            type={"secondary"}
                            style={{
                                width: 80,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                           {t("common.cancel")}
                        </YuJaButton>

                        <YuJaButton
                            onClick={handleSave}
                            disabled={isSaving}
                            style={{
                                width: 80,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                           {isSaving
                               ? <span className={classes.precessingText}>{t("common.finish")}</span>
                               : t("common.finish")
                           }
                        </YuJaButton>
                    </span>
                </div>
            </Modal.Footer>

        </Modal>
    );
}